import React from 'react';
import { navigate } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import NumberFormat from 'react-number-format';
import authHeader from '../../helpers/getEmailHeader';
import { PhoneInput } from 'react-international-phone';
import './ContactUs.scss';
import './PhoneInput.scss';

import Axios from 'axios';

export default function ContactUs({ lang }) {

  const { t } = useTranslation();

  const validate = (values) => {
    const errors = {};
    if (!values.name || !values.name.trim()) {
      errors.name = t('form.errorNameEmpty');
    } else if (values.name.trim().length < 2) {
      errors.name = t('form.errorNameShort');
    } else if (values.name.trim().length > 50) {
      errors.name = t('form.errorNameLong');
    }

    let trimmedPhoneNumber = values.phoneNumber.replace(/[`()+-\s]/gi, '');
    if (!values.phoneNumber) {
      errors.phoneNumber = t('form.errorNumberEmpty');
    } else if (trimmedPhoneNumber.length < 10) {
      errors.phoneNumber = t('form.errorNumberShort');
    }

    if (!values.email) {
      errors.email = t('form.errorEmailEmpty');
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = t('form.errorEmailInvalid');
    }

    if (!values.company || !values.company.trim()) {
      errors.company = t('form.errorCompanyEmpty');
    } else if (values.company.trim().length < 2) {
      errors.company = t('form.errorCompanyShort');
    } else if (values.company.trim().length > 100) {
      errors.company = t('form.errorCompanyLong');
    }

    if (!values.brief || !values.brief.trim()) {
      errors.brief = t('form.errorBriefEmpty');
    } else if (values.brief.trim().length < 2) {
      errors.brief = t('form.errorBriefShort');
    } else if (values.brief.trim().length > 100) {
      errors.brief = t('form.errorBriefLong');
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      phoneNumber: '',
      email: '',
      company: '',
      brief: ''
    },
    validate,
    onSubmit: values => {
      const api_url = process.env.GATSBY_API_URL || 'https://edelivery-dev.os-system.com'; // process.env.MAIL
      try {
        const resp = Axios.post(api_url + '/api/form', {
          name: values.name,
          phoneNumber: values.phoneNumber,
          email: values.email,
          site: 'apps',
          sendFrom: window.location.origin,
          companyName: values.company,
          brief: values.brief,
        }, { headers: { ...authHeader() } });
        if (process.env.NODE_ENV !== 'production') {
          console.log(resp);
        }
        navigate(`/${lang}/thank-you`);
      } catch (e) {
        console.log(e)
      }
    }
  });

  return (
    <div className='contactus-container container-fluid' id='contact-us'>
      <div className='contactus-wrapper container'>
        <h3 className='contactus-suptitle row justify-content-center'>{t('form.suptitle')}</h3>
        <h2 className='contactus-title row justify-content-center'>{t('form.title')}</h2>
        <div className='contactus-form-container mx-auto col-12 align-items-center d-flex'>
          <form onSubmit={formik.handleSubmit} id="contact-form">

            <div className='contactus-field-container'>
              <span className='field-icon icon-name' />
              <div className='contactus-input-container'>
                <input
                  type='text'
                  id='name'
                  name='name'
                  placeholder={t('form.placeholderName')}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? <label htmlFor='name'>{formik.errors.name}</label> : null}
              </div>
            </div>

            <div className='contactus-field-container'>
              <span className='field-icon icon-phone' />
              <div className='contactus-input-container number-container'>
                <PhoneInput  
                  className='flow-number-input'
                  inputProps={{id: 'phoneNumber', name: 'phoneNumber', onBlur: formik.handleBlur, maxLength: 20}}
                  onChange={(phone) => {
                    formik.setFieldValue("phoneNumber", phone);
                  }}
                  value={formik.values.phoneNumber}
                  forceDialCode
                  countrySelectorStyleProps={{
                    dropdownArrowStyle: {
                      color: 'transparent',
                    },
                    buttonStyle: {
                      border: 'none',
                      backgroundColor: 'transparent'
                    },
                  }}/>
                {formik.touched.phoneNumber && formik.errors.phoneNumber ? <label htmlFor='name'>{formik.errors.phoneNumber}</label> : null}
              </div>
            </div>

            <div className='contactus-field-container'>
              <span className='field-icon icon-email' />
              <div className='contactus-input-container'>
                <input
                  type='text'
                  id='email'
                  name='email'
                  placeholder={t('form.placeholderEmail')}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
                {formik.touched.email && formik.errors.email ? <label htmlFor='name'>{formik.errors.email}</label> : null}
              </div>
            </div>

            <div className='contactus-field-container'>
              <span className='field-icon icon-company' />
              <div className='contactus-input-container'>
                <input
                  type='text'
                  id='company'
                  name='company'
                  placeholder={t('form.placeholderCompany')}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.company}
                />
                {formik.touched.company && formik.errors.company ? <label htmlFor='name'>{formik.errors.company}</label> : null}
              </div>
            </div>

            <div className='contactus-field-container'>
              <span className='field-icon icon-brief' />
              <div className='contactus-input-container'>
                <input
                  type='text'
                  id='brief'
                  name='brief'
                  placeholder={t('form.placeholderBrief')}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.brief}
                />
                {formik.touched.brief && formik.errors.brief ? <label htmlFor='name'>{formik.errors.brief}</label> : null}
              </div>
            </div>

            <button type='submit' className='contactus-button'>{t('form.button')}</button>

          </form>
        </div>
      </div>
    </div>
  )
}
